import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Submission } from 'src/app/model/paper';
import { Track } from '../../model/track';
import { FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';
import { InfoService } from 'src/app/service/info.service';
import { SubmissionsService } from 'src/app/service/submissions.service';
import { EventsService } from '../../service/events.service';
import { FileDownloadEvent, FilesService } from 'src/app/service/files.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FileRules } from 'src/app/model/file.rules';
import { isFileRuleVisible } from 'src/app/utils/file-rule-visibility';
import { FileUploadViewDirective } from 'src/app/class/file-upload-view';
import { File } from '../../model/file';
import { CookieService } from 'ng2-cookies';
import { NavbarService } from 'src/app/service/navbar.service';
import { Subscription } from 'rxjs';
import { FileRulesCardInfoDialogComponent } from '../file-rules-card-info-dialog/file-rules-card-info-dialog.component';
import { Event } from 'src/app/model/event';
import { HttpResponse } from '@angular/common/http';
import { UPDATE_FILE_TYPE, TrackFileLoading } from '../paper-info/paper-info.component';
import { Dayjs } from 'dayjs';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/service/admin.service';
import { ActivatedRoute } from '@angular/router';

export class RulesFileSlot {
  constructor(
    public rule: FileRules,
    public file: File = null,
    public error: string = null,
    public downloading: boolean = false
  ) { }
}

@Component({
  selector: 'app-file-rules-card',
  templateUrl: './file-rules-card.component.html',
  styleUrls: ['./file-rules-card.component.scss'],
})
export class FileRulesCardComponent extends FileUploadViewDirective implements OnInit, OnChanges {
  fileDownloadPercent: number;

  rulesFileSlots: RulesFileSlot[];

  sessionId = false;
  subscriptions: Subscription[] = [];

  sbcTemplateFileInfo = {};
  slotsUpdated = false;

  @Input() submission: Submission;
  @Input() event: Event;
  @Input() isReview: boolean;
  @Input() eventTimeZone: string;
  @Input() similarityVerification: boolean;

  @Output() submissionChanged = new EventEmitter<Submission>();
  @Output() updateFileType = new EventEmitter<string>();

  @Input() userIsChair = false;

  // Overrides de perfil EFETIVO (paper-info passa effectiveAuthor/Reviewer/
  // SessionChair p/ o preview funcionar). NULL = comportamento real (usos fora
  // do paper-info). `userIsChair` já é passado como effectiveChair.
  @Input() authorView: boolean = null;
  @Input() reviewerView: boolean = null;
  @Input() sessionChairView: boolean = null;

  public uploadError: string = null;

  @Input() handlerTrackFiles: Array<TrackFileLoading>;
  private handlerResetDragOnOver: { slotID: number, handlerTime: any, debounce: number } = { slotID: null, handlerTime: null, debounce: 100 };

  constructor(
    private authService: AuthService,
    public fb: FormBuilder,
    public submissionsService: SubmissionsService,
    public eventsService: EventsService,
    public filesService: FilesService,
    public infoService: InfoService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    public cookieService: CookieService,
    private navbarService: NavbarService,
    private translateService: TranslateService,
    private adminService: AdminService,
    private route: ActivatedRoute
  ) {
    super(fb, submissionsService, filesService, eventsService, infoService);
  }

  ngOnInit() {
    this.initUploadForm();

    // Só busca o papel real de chair quando o pai NÃO controla o perfil
    // (usos fora do paper-info). No paper-info, `userIsChair` já vem como
    // effectiveChair e `authorView` é passado → não sobrescrever.
    if (this.authorView === null && !this.userIsChair) { this.setPermission(); }

    this.setTrackOfTrackFiles();

    // if (Object.keys(this.sbcTemplateFileInfo).length === 0 && !this.slotsUpdated) {
    //   this.submissionsService.updateSubmissionTrackFiles(this.submission.files.map(f => f.id)).subscribe(sbcTemplateFileInfo => {
    //     this.slotsUpdated = true;
    //     this.sbcTemplateFileInfo = sbcTemplateFileInfo;
    //   });
    // }

    this.rulesFileSlots = [];
    for (let rule of this.track.trackFiles) {
      if (this.showfile(rule)){
        let ruleFileSlot = new RulesFileSlot(rule);
        this.rulesFileSlots.push(ruleFileSlot);
        for (let file of this.submission.files) {
          if (file.trackFile.id == rule.id) {
            ruleFileSlot.file = file;

            if(this.sbcTemplateFileInfo[file.id])
              ruleFileSlot.file.isUsingSbcTemplate = this.sbcTemplateFileInfo[file.id]
          }
        }

        // Reaplica arquivo já buscado pelo fallback. ngOnChanges rechama
        // ngOnInit e recria os slots (file=null); sem isso o arquivo carregado
        // sumiria no próximo change-detection. Chave por submissão+regra: o
        // componente é reusado entre submissões (route param muda) e duas
        // submissões da MESMA trilha compartilham rule.id — sem o submissionId
        // o slot da submissão B mostraria o arquivo da submissão A.
        const cacheKey = `${this.submission.id}-${rule.id}`;
        if (!ruleFileSlot.file && this.fetchedFiles.has(cacheKey)) {
          ruleFileSlot.file = this.fetchedFiles.get(cacheKey);
        }
      }
    }

    this.loadMissingSlotFiles();
  }

  // Guard de fetch em voo (1 por submissão+regra), cache dos arquivos já
  // buscados (reaplicados nos rebuilds do ngOnChanges) e set de regras com
  // fetch em andamento (alimenta o spinner via setTrackFileLoading).
  private fetchedFileKeys = new Set<string>();
  private fetchedFiles = new Map<string, File>();   // chave `${submissionId}-${ruleId}`
  private pendingFileFetches = new Set<number>();
  private fetchAttempts = new Map<string, number>();   // tentativas por chave (teto p/ retry)

  // Fallback de arquivos: `submission.files` chega VAZIO em alguns contextos —
  // o endpoint de submissão única (getSubmission) NÃO inclui os arquivos para
  // revisor/session chair (não-autor); eles são acessíveis individualmente via
  // getFileBySubmissionTrackFile (que autoriza esses papéis). Quando não veio
  // nenhum arquivo no payload, buscamos cada slot por esse endpoint e populamos
  // o slot com uma instância de `File`.
  private loadMissingSlotFiles(): void {
    // Autor recebe seus próprios arquivos no payload do getSubmission → slot
    // vazio = "sem arquivo" (não sonda, evita 404s à toa). Para NÃO-autores
    // (revisor/session chair/chair) o getSubmission pode OMITIR os arquivos
    // (acessíveis individualmente) → sondamos cada slot vazio; isso cobre tanto
    // payload totalmente vazio quanto PARCIAL.
    if (this.userIsAuthor) { return; }
    const subId = this.submission.id;
    for (const slot of this.rulesFileSlots) {
      if (slot.file) { continue; }
      const ruleId = slot.rule.id;
      const key = `${subId}-${ruleId}`;
      if (this.fetchedFileKeys.has(key)) { continue; }
      this.fetchedFileKeys.add(key);
      this.pendingFileFetches.add(ruleId);   // spinner enquanto carrega
      this.filesService.getFileBySubmissionTrackFile(subId, ruleId).subscribe(data => {
        this.pendingFileFetches.delete(ruleId);
        if (!data || !data.id) { return; }
        // Constrói o File MANUALMENTE — `plainToClass(File)` quebra porque o
        // payload traz `name`, e File.name é getter sem setter (atribuir lança).
        const file = new File(data.id, data.file, data.size, data.date);
        file.trackFile = slot.rule;
        file.pageCount = data.pageCount;
        file.isUsingSbcTemplate = data.isUsingSbcTemplate;
        this.fetchedFiles.set(key, file);
        // Só aplica se ainda for a MESMA submissão (evita aplicar resultado
        // tardio depois que o @Input mudou para outra submissão).
        if (this.submission.id === subId) {
          const target = this.rulesFileSlots.find(s => s.rule.id === ruleId);
          if (target) { target.file = file; }
        }
      }, (err) => {
        this.pendingFileFetches.delete(ruleId);
        // 404 = regra sem arquivo (terminal, mantém a chave p/ não re-sondar).
        // Outros status (rede/5xx) podem ser transitórios: libera a chave p/
        // permitir nova tentativa num próximo ngOnChanges, com teto de 2 p/
        // não criar retry-storm em falha persistente.
        if (err && err.status !== 404) {
          const attempts = (this.fetchAttempts.get(key) || 0) + 1;
          this.fetchAttempts.set(key, attempts);
          if (attempts < 2) { this.fetchedFileKeys.delete(key); }
        }
      });
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  // Perfil EFETIVO (respeita o seletor via os *View inputs; senão o papel real).
  public get userIsAuthor(): boolean {
    return (this.authorView !== null && this.authorView !== undefined)
      ? this.authorView
      : this.submission.isAuthor(this.infoService.user?.id);
  }
  private get effectiveReviewer(): boolean {
    return (this.reviewerView !== null && this.reviewerView !== undefined)
      ? this.reviewerView
      : this.submission.flagReviewer;
  }
  private get effectiveSessionChair(): boolean {
    return (this.sessionChairView !== null && this.sessionChairView !== undefined)
      ? this.sessionChairView
      : this.submission.isSessionChair(this.infoService.user?.id);
  }

  // Delega ao helper compartilhado: a MESMA decisão precisa valer nos cards da
  // lista, que antes não filtravam nada (issue #2381). Os flags aqui já são
  // "effective" — respeitam o seletor de perfil do paper-info.
  private showfile(rule: FileRules): boolean {
    return isFileRuleVisible(rule, {
      isAuthor: this.userIsAuthor,
      isChair: this.userIsChair,
      isReviewer: this.effectiveReviewer,
      isSessionChair: this.effectiveSessionChair,
    });
   }

  private setPermission() {
    this.authService.userIsAdminOrChair(this.event.id).subscribe(isChairOrAdmin => {
      this.userIsChair = isChairOrAdmin;
    });
  }

  fileUploaded(event: {slot: RulesFileSlot, status: number}, isComplete: boolean, isUpdate: boolean) {
    if (event.status === 100) {
      this.updateFileType.emit(UPDATE_FILE_TYPE.UPLOAD);
      event.slot.error = null;
      event.slot.rule.uploadStatus = undefined;
      const trackFiles = (<Track>this.submission.track).trackFiles;
      this.verifyAndUpdateStatus(this.submission, event.slot.rule, trackFiles, this.submissionChanged);
      this.handlerTrackFiles.find(trackFile => trackFile.id === event.slot.rule.id).loading = true;

      if (isComplete) {
        if (this.needSbcTemplate(event.slot)) {
          this.filesService.getFileBySubmissionTrackFile(this.submission.id, event.slot.rule.id).subscribe((file) => {
            if (!file.isUsingSbcTemplate)
              this.notificationService.notifyError("file-rules-view.file-not-using-sbc-template", { snackbarConfig: { panelClass: 'notification', horizontalPosition: 'left', verticalPosition: 'bottom',duration: 0 }})
            else if (isUpdate)
              this.notificationService.notify('file-rules-view.file-updated', { params: { id: this.submission.id } });
          }, () => {
            // O handler global de erro é suprimido p/ este endpoint (probe de
            // arquivos). Tratamos localmente: a checagem de template SBC é
            // pós-upload e não-crítica — o upload em si já concluiu.
          })
        } else if (isUpdate)
          this.notificationService.notify('file-rules-view.file-updated', { params: { id: this.submission.id } });
      }
    } else {
      event.slot.rule.uploadStatus = event.status;
    }
    this.handlerTrackFiles.find(trackFile => trackFile.id === event.slot.rule.id).statusUpload = event.status;
  }

  uploadErrorRaised(error: string) : void {
    this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true, autoFocus: false,
      data: {
        title: error,
        content: '',
        params: { onlyOkButton: true }
      }
    });
  }

  public handlerDragOver(slotID: number) {
    this.handlerTrackFiles.find(trackFile => trackFile.id === slotID).onOver = true;

    if (this.handlerResetDragOnOver.slotID === slotID) clearTimeout(this.handlerResetDragOnOver.handlerTime);
  }

  public resetDragOnOver(slotID: number) {
    this.handlerResetDragOnOver.slotID = slotID;
    this.handlerResetDragOnOver.handlerTime = setTimeout(() => {
      this.handlerTrackFiles.find(trackFile => trackFile.id === slotID).onOver = false;
    }, this.handlerResetDragOnOver.debounce);
  }

  public isDragOnOver(slotID: number): boolean {
    if (!this.handlerTrackFiles) return false;

    return this.handlerTrackFiles?.find(trackFile => trackFile.id === slotID).onOver;
  }

  public isUploading(slotID: number): string | boolean {
    if (!this.handlerTrackFiles) return '100%';

    const statusUpload = this.handlerTrackFiles.find(trackFile => trackFile.id === slotID).statusUpload;

    return statusUpload === 0 ? '100%' : `${statusUpload}%`;
  }

  public submitFile($event: {file: File, rule: FileRules, slot: RulesFileSlot}) {
    this.resetDragOnOver($event.slot.rule.id);
    const file = $event.file;
    const rules = $event.rule;
    const slot = $event.slot;

    const submitFile = {
      [rules.name]: [file]
    };

    const isUpdate: boolean = this.isUpdateFile(rules.name, this.submission.files);
    this.submissionsService.submitFiles(submitFile, this.submission.id, rules.track)
      .subscribe({
        next: statusList => {
          this.fileUploaded({slot, status: statusList[0].status}, false, isUpdate);
        },
        complete: () => {
          this.fileUploaded({slot, status: 100}, true, isUpdate);
        }
      });
  }

  private isUpdateFile(trackName: string, files: File[]): boolean {
    for (let file of files) {
      if (file.trackFile.name === trackName) {
        return true;
      }
    }
    return false;
  }

  // Classe do ícone de tipo de arquivo (Phosphor Icons), MESMO ícone usado no
  // `app-file-pill` de "Minhas Submissões" — por extensão do arquivo. Phosphor é
  // carregado globalmente (index.html). Renderizado em `<i class="ph ph-...">`.
  public getFileIconClass(file: any): string {
    const name = (file?.name || file?.file || '').toString().toLowerCase();
    const ext = name.split('.').pop() || '';
    const map: Record<string, string> = {
      pdf: 'file-pdf',
      doc: 'file-doc', docx: 'file-doc',
      odt: 'file-text', rtf: 'file-text', txt: 'file-text', ps: 'file-text',
      zip: 'file-zip', rar: 'file-zip', '7z': 'file-zip', tar: 'file-zip', gz: 'file-zip',
      mp4: 'file-video', mpg: 'file-video', mov: 'file-video', avi: 'file-video', mkv: 'file-video',
      html: 'file-html', htm: 'file-html',
      jpg: 'file-jpg', jpeg: 'file-jpg',
      png: 'file-png', svg: 'file-svg',
      csv: 'file-csv',
      xls: 'file-xls', xlsx: 'file-xls',
    };
    return `ph ph-${map[ext] || 'file'}`;
  }

  downloadFile(rFile: RulesFileSlot) {
    const file: File = rFile.file;
    rFile.downloading = true;

    let downloadURL = file.url;
    // this.sessionId = this.cookieService.check('csrftoken');
    if (!this.sessionId) {
      // this.setSessionId();  // If to set sessionId cookie
      this.navbarService.loadingStart();
      let contentType = file.type ? file.type : 'application/pdf';
      // if (file.type) {
      //   let contentType = file.type;
      // }
      this.subscriptions.push(this.filesService.downloadFileWithProgress(file.id).subscribe((event : FileDownloadEvent) => {

        if (event.progress) {
          this.fileDownloadPercent = event.progress;
        }

        if(event.response instanceof HttpResponse){
          let blob = new Blob([event.response.body], { type: contentType });
          downloadURL = URL.createObjectURL(blob);
        }
      }, () => { },
        () => {
          this.navbarService.loadingStop();
          this.downloadLink(downloadURL, file.name);
          rFile.downloading = false;
        }));
      } else {
        this.downloadLink(downloadURL, file.name);
        rFile.downloading = false;
    }
  }

  downloadLink(downloadURL: string, fileName: string) {
    // Create link to download
    var link = document.createElement('a');
    link.href = downloadURL;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = fileName;
    link.click();
  }

  setSessionId() {
    this.authService.getSessionId().subscribe(
      response => {
        let sessionId = response.data;
        if (sessionId) {
          this.cookieService.set('sessionid', sessionId, 30, '/');
        }
      });
  }

  openDetailsDialog(slot: RulesFileSlot) {
    this.dialog.open(FileRulesCardInfoDialogComponent, { data: { rule: slot.rule } });
  }

  needSbcTemplate(slot: RulesFileSlot) {
    return slot.rule && slot.rule.useOfSbcTemplate && slot.file && typeof slot.file.isUsingSbcTemplate !== 'undefined';
  }

  isUsingSbcTemplate(slot: RulesFileSlot) {
    return slot.file && slot.file.isUsingSbcTemplate;
  }

  deleteFile(slot: RulesFileSlot) {
    this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true, autoFocus: false,
      data: {
        title: 'messages.confirm-file-deletion',
        content: ''
      }
    }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.submissionsService.deleteSubmissionFile(slot.file, this.submission).subscribe(() => {
          this.updateFileType.emit(UPDATE_FILE_TYPE.DELETE);
          this.submissionsService.getSubmission(this.submission.id, true).subscribe(sub => {
            this.submissionSetEventAndTrack(sub, this.submissionChanged);
            this.submission = sub;
          });
        });
      }
    });
  }

  public setTrackFileLoading(trackFileID: number): boolean {
    // Fetch de arquivo do fallback em voo → mostra o spinner em vez do ícone
    // de "sem arquivo" (evita o flicker noFile → arquivo).
    if (this.pendingFileFetches.has(trackFileID)) {
      return true;
    }
    if (!this.handlerTrackFiles) {
      return false;
    }
    const entry = this.handlerTrackFiles.find(trackFile => trackFile.id === trackFileID);
    return entry ? entry.loading : false;
  }

  public hasDeadlinePassed(deadline: Dayjs): boolean {
    return deadline.toDate() < new Date();
  }

  public isExceedingPageLimit(slot: RulesFileSlot): boolean {
    if (!slot.file.pageCount || !slot.rule.maxPages) {
      return false;
    }

    return slot.file.pageCount > slot.rule.maxPages;
  }

  public submitFileToSimilarityCheck(file: File) {
    this.adminService.progressBar.start();
    this.filesService.submitFileToSimilarityCheck(file).subscribe((success) => {
      if(success){
        file.submittedToVerification = true;
      } else { 
        this.notificationService.notifyError(this.translateService.instant(`errors.failed-file-verification`));
      }
      this.adminService.progressBar.stop();
    });
  }

  public downloadSimilarityReport(file: File) {
    this.filesService.downloadSimilarityReport(file).subscribe({
      next: (result) => {
        if (!result) {
          this.notificationService.notifyError(
            this.translateService.instant('errors.failed-download-report')
          );
        }
      },
      error: () => {
        this.notificationService.notifyError(
          this.translateService.instant('errors.unexpected-error')
        );
      }
    });
  }
}